import React from 'react';
import styles from './DealerHome.module.css';
import { CardBody } from 'reactstrap';
import { ReactComponent as InfoIcon } from '../../assets/images/info-icon.svg';
import { getBrandContent } from '../../components/BrandingWhiteLabel/BrandContent';
import { SessionContext } from '../../context/SessionContext';
import { useContext } from 'react';

// card bg icons
import ContractActive from '../../assets/images/contract-active.svg';
import ContractPending from '../../assets/images/contract-pending.svg';
import SaleIncomplete from '../../assets/images/sale-incomplete.svg';
import AdvantageIcon from '../../assets/images/shield-check.svg';
import GEPaymentHistory from '../../assets/images/Vendor/GE/payment-history_home.svg';
import ContractClaims from '../../assets/images/contract-claims.svg';

const UpperCard = ({
    amount = '0',
    category = '',
    image, // WHICH ICON TO USE: active | pending | incomplete | advantage
    isPendingPayment,
    isAdvatageCard,
    onCardClick
}) => {
    const context = useContext(SessionContext);
    const { accountName } = context;

    const getCardIcon = () => {
        const accountNameLower = accountName.toLowerCase();

        // REPEAT THIS "IF" FOR EACH NEW BRAND

        if (accountNameLower === 'ge') {
            if (image.toLowerCase() === 'history') return GEPaymentHistory;
        }

        if (accountNameLower === 'mcc') {
            if (image.toLowerCase() === 'service') return AdvantageIcon;
        }

        // FALLTHROUGH IF CLIENT NOT DEFINED OR NO MATCH FOUND
        if (image.toLowerCase() === 'active') return ContractActive;
        if (image.toLowerCase() === 'pending') return ContractPending;
        if (image.toLowerCase() === 'incomplete') return SaleIncomplete;
        if (image.toLowerCase() === 'advantage') return AdvantageIcon;
        if (image.toLowerCase() === 'history') return ContractPending;
        if (image.toLowerCase() === 'claim') return ContractClaims;

        // FALLTHROUGH IF NO MATCH ON CLIENT OR TYPE.
        return null;
    };

    return (
        <CardBody
            type='button'
            className={styles.upperCard}
            style={{ backgroundImage: `url(${getCardIcon()})` }}
            onClick={onCardClick}
        >
            <p className={isAdvatageCard ? styles.advCard : styles.numberOf}>{amount}</p>
            <p className={styles.categoryName}>
                {category}
                {isPendingPayment && (
                    <span className={styles.pendingInfoTooltip}>
                        <InfoIcon />
                        <span className={styles.pendingInfoTooltiptext}>
                            {`${getBrandContent(accountName).advantageProgramName} contracts pending that require payment.`}
                        </span>
                    </span>
                )}
            </p>
        </CardBody>
    );
};

export default UpperCard;
